<template>
    <div>
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item prop="">
          <j-language size="large" width="100%"></j-language>
        </a-form-model-item>
        <a-form-model-item required prop="username">
          <a-input v-model="model.username" size="large" :placeholder="language['system.loginUser']">
            <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
          </a-input>
        </a-form-model-item>
        <a-form-model-item required prop="password">
          <a-input-password v-model="model.password" size="large" type="password" autocomplete="false" :placeholder="language['system.loginPassword']">
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
          </a-input-password>
        </a-form-model-item>

        <a-row :gutter="0">
          <a-col :span="16">
            <a-form-model-item required prop="inputCode">
              <a-input v-model="model.inputCode" size="large" type="text" :placeholder="language['system.verificationCode']">
                <a-icon slot="prefix" type="smile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8" style="text-align: right">
            <img v-if="requestCodeSuccess" style="margin-top: 2px;" :src="randCodeImage" @click="handleChangeCheckCode"/>
            <img v-else style="margin-top: 2px;" src="../../assets/checkcode.png" @click="handleChangeCheckCode"/>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import JLanguage from '@/components/jeecg/JLanguage'
  import {ACCESS_TOKEN, ENCRYPTED_STRING, LANGUAGE, USER_INFO} from '@/store/mutation-types'


  const LANG_CODE = {
    [LANGUAGE.CN]: 'cn',
    [LANGUAGE.TW]: 'tw',
    [LANGUAGE.ES]: 'en',
    [LANGUAGE.VN]: 'vn',
    [LANGUAGE.JP]: 'en'
  }

  export default {
    name: 'LoginAccount',
    components: {
      JLanguage
    },
    data(){
      return {
        requestCodeSuccess: false,
        randCodeImage: '',
        currdatetime: '',
        loginType: 0,
        model:{
          username: '',
          password: '',
          inputCode: ''
        },
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        if(this.language){
          return {
            username:[
              { required: true, message: this.language['system.loginUser']+'!'},
              {validator: this.handleUsernameOrEmail}
            ],
            password:[
              { required: true, message: this.language['system.loginPassword']+'!',validator: 'click'}
            ],
            inputCode:[
              { required: true, message: this.language['system.verificationCode']+'!'}
            ]
          }
        }
      },
    },
    created() {
      this.handleChangeCheckCode();
    },
    methods:{
      ...mapActions(['Login','LoginVerify']),
      /**刷新验证码*/
      handleChangeCheckCode(){
        this.currdatetime = new Date().getTime();
        this.model.inputCode = ''
        getAction(`/sys/randomImage/${this.currdatetime}`).then(res=>{
          if(res.success){
            this.randCodeImage = res.result
            this.requestCodeSuccess=true
          }else{
            this.$message.error(res.message)
            this.requestCodeSuccess=false
          }
        }).catch(()=>{
          this.requestCodeSuccess=false
        })
      },
      // 判断登录类型
      handleUsernameOrEmail (rule, value, callback) {
        const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
        if (regex.test(value)) {
          this.loginType = 0
        } else {
          this.loginType = 1
        }
        callback()
      },
      /**
       * 验证字段
       * @param arr
       * @param callback
       */
      validateFields(arr, callback){
        let promiseArray = []
        for(let item of arr){
          let p = new Promise((resolve, reject) => {
            this.$refs['form'].validateField(item, (err)=>{
              if(!err){
                resolve();
              }else{
                reject(err);
              }
            })
          });
          promiseArray.push(p)
        }
        Promise.all(promiseArray).then(()=>{
          callback()
        }).catch(err=>{
          callback(err)
        })
      },
      acceptUsername(username){
        this.model['username'] = username
      },
      //账号密码登录
      handleLogin(rememberMe){
        this.validateFields([ 'username', 'password', 'inputCode' ], (err)=>{
          if(!err){
            let loginParams = {
              username: this.model.username,
              password: this.model.password,
              captcha: this.model.inputCode,
              checkKey: this.currdatetime,
              remember_me: rememberMe,
            }
            
            this.LoginVerify(loginParams).then((res) => {
                if(res.success){
                  // this.$emit('success', res.result)
                  let login_hint = res.result.login_hint
                  let signature = res.result.signature
                  let ssoExtData = res.result.ssoExtData

                  const lang = 'zh_CN';
                  const url = `${process.env.VUE_APP_SSO_VENDOR_URI}&lang=${LANG_CODE[lang]}&login_hint=${login_hint}&signature=${signature}`+'&ext_data='+ssoExtData;
                  window.location.href = url
                }else {
                  this.$emit('fail', res.message)
                }
            }).catch((err)=>{
              this.$emit('fail', err)
            })
          }else{
            this.$emit('validateFail')
          }
        })
      }


    }

  }
</script>

<style scoped>

</style>